import type { one_to_one } from '@fireworkhq/proto-contract'
import { useChatChannelConfig } from '@liveHelper/context/ChatChannelConfigContext'
import { actionsSelector, useStore } from '@liveHelper/models/store'

import { uuidv4 } from '@core/helpers/uuidv4'
import { useContextTranslation } from '@core/i18n'

/**
 * Hook to show welcome message.
 */
export const useShowWelcomeMessage = () => {
  const { t } = useContextTranslation()

  const { addChatMessages } = useStore(actionsSelector)

  const chatChannelConfig = useChatChannelConfig()

  const showWelcomeMessage = () => {
    const message: one_to_one.shared.Message = {
      client_msg_ref: uuidv4(),
      created_at: new Date().toISOString(),
      text_message: {
        content:
          chatChannelConfig?.config?.welcome_message ||
          t('oneToOne:How may I help you?'),
        author: 'AUTHOR_AGENT',
      },
    }
    addChatMessages([message], 'visitor')
  }

  return showWelcomeMessage
}
